import React, { PureComponent } from 'react';

import strings from 'app/locales/contact';

import Intro from 'app/components/Intro';
import Newsletter from 'app/components/Newsletter';

import styles from './styles.css';

class Contact extends PureComponent {
  render() {
    const { intro, newsletter } = strings;

    return (
      <div className={styles.container}>
        <Intro {...intro} hasDarkBg={true} />
        <Newsletter {...newsletter} />
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/routes/Contact/index.js